import {
  Button,
  Drawer,
  DrawerBody,
  IconButton,
  Popover,
  useBreakpoints,
} from "@aurem/ui";
import { GlobeIcon } from "lucide-react";
import { useState } from "react";
import { useTranslations } from "../i18n";
import LanguageCurrencyPickerContent from "./Content";
import { LanguageCurrencyPickerContext } from "./context";
import {
  LanguageCurrencyPickerContextType,
  LanguageCurrencyPickerProps,
} from "./types";

export const LanguageCurrencyPicker = (props: LanguageCurrencyPickerProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { rtl } = useTranslations();
  const { isMobile } = useBreakpoints();
  const supportedLanguages = process.env.LANGUAGES_SUPPORTED?.split(",") || [
    "en",
  ];

  const context: LanguageCurrencyPickerContextType = {
    ...props,
    isOpen,
    setIsOpen,
    supportedLanguages,
  };

  const { currentCurrency, currentLanguage } = context;
  let displayText = rtl
    ? `${currentCurrency} - ${currentLanguage}`
    : `${currentLanguage} - ${currentCurrency}`;
  if (supportedLanguages.length <= 1) {
    displayText = currentCurrency;
  }
  return (
    <LanguageCurrencyPickerContext value={context}>
      {isMobile ? (
        <>
          <IconButton
            variant="ghost"
            color="neutral"
            // eslint-disable-next-line tailwindcss/no-custom-classname
            className="language-settings-tour-step"
            onClick={() => setIsOpen(true)}
          >
            <GlobeIcon className="min-w-6 min-h-6" size={24} />
          </IconButton>
          <Drawer
            open={isOpen}
            onOpenChange={setIsOpen}
            side="bottom"
            className="max-h-[23rem] h-full"
          >
            <DrawerBody className="pt-2">
              <LanguageCurrencyPickerContent />
            </DrawerBody>
          </Drawer>
        </>
      ) : (
        <Popover
          open={isOpen}
          onOpenChange={setIsOpen}
          content={<LanguageCurrencyPickerContent />}
          placement="bottom-end"
          contentClassName="px-6 pb-6 pt-2 z-[60]"
          minWidth={320}
        >
          <Button
            variant="ghost"
            color="neutral"
            // eslint-disable-next-line tailwindcss/no-custom-classname
            className="w-[116px] language-settings-tour-step"
            startIcon={<GlobeIcon className="min-w-6 min-h-6" size={24} />}
          >
            {displayText.toUpperCase()}
          </Button>
        </Popover>
      )}
    </LanguageCurrencyPickerContext>
  );
};
